<template>
  <div class="b-table-container mb-3">
    <div class="flex-container">
      <div class="search noprint" v-if="search_filter">
        <b-input-group size="sm">
          <b-input-group-prepend is-text>
            <b-icon icon="search"></b-icon>
          </b-input-group-prepend>
          <b-form-input
            id="search-form"
            type="search"
            v-model="input_search"
            :placeholder="$t('reusable.common.searchPlaceholder')"
            @input="resetTableRecords"
          >
          </b-form-input>
          <b-input-group-append>
            <!-- <b-button
              class="btn-clear"
              :disabled="!input_search"
              @click="input_search = ''"
              >{{ $t("reusable.common.clear") }}</b-button
            > -->
            <div
              v-if="show_loading"
              class="spinner-border text-secondary ml-2"
              role="status"
            >
              <span class="sr-only">{{ $t("reusable.common.loading") }}</span>
            </div>
          </b-input-group-append>
        </b-input-group>
      </div>
      <div class="columns-btn noprint">
        <div class="column-selector noprint" v-if="columns_display">
          <div class="d-flex">
            <VisibleColumns
              :id_button="`col-display-1-${display_id}`"
              :tooltip_text="''"
            >
              <template #popover-title>
                {{ $t("reusable.common.displayColumns") }}
              </template>
              <template #popover-content>
                <div
                  class="column-check noprint"
                  v-for="(field, index) in $props.fields"
                  :key="index"
                >
                  <b-form-checkbox
                    v-if="field.label != ''"
                    :disabled="
                      (dynamicFields.length == 1 && field.display_column) ||
                      (dynamicFields[0].key == 'selected' &&
                        dynamicFields.length == 2 &&
                        field.display_column) ||
                      (dynamicFields[dynamicFields.length - 1].key ==
                        'actions' &&
                        dynamicFields.length == 2 &&
                        field.display_column)
                    "
                    :id="`column-check-${index}`"
                    v-model="field.display_column"
                    name="checkbox-1"
                  >
                    {{ field.label }}
                  </b-form-checkbox>
                </div>
              </template>
            </VisibleColumns>
            <!-- <b-button
              :id="`col-display-1-${display_id}`"
              class="col-display-1"
              variant="none"
              size="sm"
              >Visualizar columnas</b-button
            > -->
            <slot name="btn-download"></slot>
          </div>
          <!-- <b-popover
            :id="`columns-popover-1-${display_id}`"
            :target="`col-display-1-${display_id}`"
            placement="bottom"
            class="col-popover-1"
            triggers="click blur"
          >
            <div
              class="column-check noprint"
              v-for="(field, index) in $props.fields"
              :key="index"
            >
              <b-form-checkbox
                v-if="field.label != ''"
                :disabled="
                  (dynamicFields.length == 1 && field.display_column) ||
                  (dynamicFields[0].key == 'selected' &&
                    dynamicFields.length == 2 &&
                    field.display_column) ||
                  (dynamicFields[dynamicFields.length - 1].key == 'actions' &&
                    dynamicFields.length == 2 &&
                    field.display_column)
                "
                :id="`column-check-${index}`"
                v-model="field.display_column"
                name="checkbox-1"
              >
                {{ field.label }}
              </b-form-checkbox>
            </div>
          </b-popover> -->
        </div>
        <div
          class="column-selector noprint"
          v-if="search_filter && view_filter_by"
        >
          <b-button
            :id="`col-display-2-${display_id}`"
            class="col-display-2"
            variant="primary"
            size="sm"
            >{{ $t("reusable.common.filterBy") }}</b-button
          >
          <b-popover
            :id="`columns-popover-2-${display_id}`"
            :target="`col-display-2-${display_id}`"
            placement="bottom"
            custom-class="filteron-popover"
            bottom
            triggers="click blur"
          >
            <b-form-group
              v-model="sortDirection"
              label-size="sm"
              :description="$t('reusable.common.deselectAllToFilter')"
              class="mb-0 filter-by-column noprint"
              v-slot="{ ariaDescribedby }"
            >
              <b-form-checkbox-group
                v-model="filterOn"
                :aria-describedby="ariaDescribedby"
                class="mt-1"
              >
                <div v-for="(field, index) in $props.fields" :key="index">
                  <b-form-checkbox
                    v-if="field.label != '' && !field.hidden_key"
                    :value="field.key"
                    class="check-filteron"
                    >{{ field.label }}</b-form-checkbox
                  >
                </div>
              </b-form-checkbox-group>
            </b-form-group>
          </b-popover>
        </div>
      </div>
    </div>
    <TableSkeleton
      v-if="is_loading || this.busy"
      :columns="dynamicFields ? dynamicFields.length : null"
      :rows="$props.items && $props.items.length ? $props.items.length : null"
      :table_props="{ bordered: true, striped: true }"
    ></TableSkeleton>
    <b-table
      id="generic-table"
      v-else
      class="generic-table"
      :class="{ 'no-header': hidden_table_header }"
      thead-class="b-card-style text-center"
      tfoot-class="custom-footer"
      v-bind="$props"
      v-on="$listeners"
      :busy="isBusy"
      :filter="input_search"
      :filter-included-fields="filterOn"
      :filter-function="filterCustom"
      :fields="dynamicFields"
      :per-page="per_page"
      :current-page="current_page"
      :filtered="filteredItems"
      show-empty
      small
      :bordered="default_bordered"
      :borderless="default_borderless"
      :striped="default_striped"
      responsive
      :selectable="show_select_mode"
      :select-mode="select_mode"
      :hover="default_hover"
      @row-selected="slotSelected"
      @filtered="onFiltered"
      :empty-text="$t('reusable.common.noDataToShow')"
      :empty-filtered-text="$t('reusable.common.noMatchingData')"
      primary-key="id"
      @sort-changed="onSortChanged"
      :no-local-sorting="false"
    >
      <template #head()="{ label, field: { key, sortable } }">
        <div class="custom-th">
          {{ label }}
          <template v-if="sortable">
            <b-img
              v-if="current_sort_by !== key"
              :src="sortIconNeutral"
              class="sort-arrow"
            ></b-img>
            <b-img
              v-else-if="current_sort_desc"
              :src="sortIconAsc"
              class="sort-arrow"
            ></b-img>
            <b-img v-else :src="sortIconDesc" class="sort-arrow"></b-img>

            <!-- Respaldo en caso de que se quiera cambiar a íconos de bootstrap -->
            <!-- <div v-if="sortBy !== key" class="sort-arrows">
              <b-icon icon="triangle" scale=".6"> </b-icon>
              <b-icon class="arrow-down" icon="triangle" scale=".6"> </b-icon>
            </div>
            <div v-else-if="sortDesc" class="sort-arrows">
              <b-icon icon="triangle" scale=".6"> </b-icon>
              <b-icon class="arrow-down" icon="triangle-fill" scale=".6"> </b-icon>
            </div>
            <div v-else class="sort-arrows">
              <b-icon icon="triangle-fill" scale=".6"> </b-icon>
              <b-icon class="arrow-down" icon="triangle" scale=".6"> </b-icon>
            </div> -->
          </template>
        </div>
      </template>
      <template #table-busy>
        <div class="text-center">
          <b-spinner></b-spinner>
        </div>
      </template>
      <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
        <slot :name="slot" v-bind="scope" />
      </template>
      <template v-if="show_pagination" v-slot:custom-foot="row">
        <div class="footer-caption noprint" colspan="0">
          <i
            >{{ $t("reusable.common.showing") }}
            {{ row.items.length }}
            {{ $t("reusable.common.of") }} {{ items.length }}
            {{ $t("reusable.common.rowsTotal") }}</i
          >
        </div>
      </template>
    </b-table>

    <div class="pagination-bar d-flex mt-2 mb-3 noprint" v-if="show_pagination">
      <div class="d-flex align-items-center">
        <span class="custom-span-pagination mr-1">
          {{ $t("reusable.common.perPage") }}
        </span>
        <b-form-select
          id="per-page-input"
          v-model="per_page"
          size="sm"
          class="custom-input-pagination"
          :options="per_page_options"
          v-b-tooltip.v-secondary.noninteractive="
            $t('reusable.common.perPageTooltip')
          "
        ></b-form-select>
      </div>
      <!-- {{ items.length }} {{ per_page }}
      {{ Math.ceil(this.items.length / this.per_page) }} -->
      <div class="noprint ml-auto" v-if="show_pagination">
        <b-pagination
          :key="current_page"
          v-model="current_page"
          :total-rows="items.length"
          :per-page="per_page"
          :disabled="per_page == items.length"
          size="sm"
          class="my-0"
          no-title
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { BTable } from "bootstrap-vue";
import { generateUniqueId } from "@/utils/utils";

export default {
  name: "GenericBTable",
  components: {
    TableSkeleton: () => import("@/components/reusable/TableSkeleton"),
    VisibleColumns: () =>
      import("@/components/reusable/Buttons/VisibleColumns"),
  },
  mixins: [BTable],
  props: {
    pagination: {
      type: Number,
      default: 20,
    },
    allows_crud: {
      type: Boolean,
      default: true,
    },
    hidden_headers: {
      type: Array,
    },
    show_pagination: {
      type: Boolean,
      default: false,
    },
    search_filter: {
      type: Boolean,
      default: true,
    },
    columns_display: {
      type: Boolean,
      default: true,
    },
    selection_mode: {
      type: Boolean,
      default: false,
    },
    show_select_mode: {
      type: Boolean,
      default: false,
    },
    select_mode: {
      type: String,
      default: "single",
    },
    //select_mode: single, multi, range
    view_filter_by: {
      type: Boolean,
      default: false,
    },
    delay_input: {
      type: Boolean,
      default: false,
    },
    filterCustom: {
      type: Function,
    },
    item_created_id: {
      default: generateUniqueId(),
    },
    busy: {
      default: false,
    },
    default_striped: {
      default: true,
    },
    default_bordered: {
      default: true,
    },
    default_borderless: {
      default: true,
    },
    default_hover: {
      default: false,
    },
    insert_search: {
      type: String,
      default: "",
    },
    // ocultar el header completamente
    hidden_table_header: {
      default: false,
    },
    show_skeleton_efect: {
      default: true,
    },
    item_created_index: {},
    // sort_by: {},
    display_id: {},
  },
  data() {
    return {
      per_page: Number(this.pagination) || 10,
      current_page: 1,
      total_rows: 1,
      columns_selected: this.$props.fields,
      table_items: this.$props.items,
      input_search: this.insert_search,
      window_top: 0,
      filterOn: [],
      last_page: false,
      is_loading: false,
      sorted_items: null,
      show_loading: false,
      timeoutId: null,
      filtered_items: [],
      // Orden reportado por la tabla; null mientras no se haya hecho clic
      sort_by_state: null,
      sort_desc_state: null,
      sortIconNeutral:
        "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' opacity='.3' d='M51 1l25 23 24 22H1l25-22zM51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e",
      sortIconDesc:
        "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='black' opacity='.3' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e",
      sortIconAsc:
        "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' opacity='.3' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='black' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e",
    };
  },
  computed: {
    // selectColumn(){

    // },
    per_page_options() {
      const base = [10, 25, 50, 100];
      const current = Number(this.per_page);
      if (current && !base.includes(current)) {
        base.push(current);
        base.sort((a, b) => a - b);
      }
      return base;
    },
    isBusy() {
      if (!this.$props.items) return true;
      return false;
    },
    // El padre no siempre enlaza sort-by/sort-desc con .sync, así que la prop se
    // queda congelada y las flechas del encabezado nunca cambiarían
    current_sort_by() {
      return this.sort_by_state !== null
        ? this.sort_by_state
        : this.$props.sortBy;
    },
    current_sort_desc() {
      return this.sort_desc_state !== null
        ? this.sort_desc_state
        : this.$props.sortDesc;
    },
    dynamicFields() {
      let fields = [];
      if (this.selection_mode) {
        fields.push({
          key: "selected",
          label: this.$t("reusable.common.selectLabel"),
          thStyle: { width: "1%" },
        });
      }

      fields = this.columns_selected.filter((field) => field.display_column);
      return fields;
    },
  },
  methods: {
    slotSelected(rows) {
      this.$emit("selected", rows);
    },
    emitUpdate() {
      this.$emit("emitUpdate");
    },
    onFiltered(filteredItems) {
      this.filtered_items = filteredItems;
      this.emitActualItems();
    },
    emitActualItems() {
      const start = (this.current_page - 1) * this.per_page;
      const end = start + this.per_page;
      const items_to_emit =
        this.filtered_items.length > 0
          ? this.filtered_items.slice(start, end)
          : this.$props.items.slice(start, end);
      this.$emit("actual_items", items_to_emit);
    },
    resetTableRecords() {
      if (this.input_search != "") this.current_page = 1;
    },
    scrollView() {
      /**
       * Primero se determina el elemento al cual asignar el método,
       * en este caso por referencia al id del elemento con document.getElementById.
       */
      const element = document.getElementById("generic-table");
      /**
       * "Behavior" establece la transición de la animación (auto o smooth).
       * "Block" establece el alineamiento vertical.
       * "Inline" establece el alineamiento horizontal.
       *
       *
       */
      if (this.items.length <= this.per_page) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        });
      } else if (this.per_page && this.items.length) {
        /**
         * Math.ceil() redondea hacia arriba el número resultante, obteniendo en este
         * caso la última página en la tabla actual cuando se quiere agregar un nuevo elemento
         *
         */
        this.current_page = Math.ceil(this.items.length / this.per_page);
        element.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        });
      }
    },
    last() {
      this.last_page = true;
    },
    onSortChanged(event) {
      this.sort_by_state = event.sortBy;
      this.sort_desc_state = event.sortDesc;
      this.slotSortChanged(event);
    },
    slotSortChanged(event) {
      this.is_loading = false;
      if (!this.item_created_id) return;
      let table_sort = this.table_items.sort(
        this.dynamicSort(event.sortBy, event.sortDesc)
      );
      this.table_items = table_sort;
    },
    dynamicSort(property, sortDesc = false) {
      if (!property) return;
      const sortOrder = sortDesc ? -1 : 1;
      return function (a, b) {
        // Soportar propiedades anidadas
        const aValue = property.split(".").reduce((o, i) => o[i], a);
        const bValue = property.split(".").reduce((o, i) => o[i], b);
        // Manejar valores undefined o null
        if (aValue == null && bValue == null) return 0;
        if (aValue == null) return -1 * sortOrder;
        if (bValue == null) return 1 * sortOrder;
        // Convertir a string y comparar
        const aValueStr =
          typeof aValue === "string" ? aValue.toLowerCase() : aValue.toString();
        const bValueStr =
          typeof bValue === "string" ? bValue.toLowerCase() : bValue.toString();
        let result = aValueStr < bValueStr ? -1 : aValueStr > bValueStr ? 1 : 0;
        return result * sortOrder;
      };
    },
  },
  watch: {
    input_search: function (n, o) {
      if (this.delay_input) {
        this.show_loading = true;
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(() => {
          if (n !== o) {
            this.show_loading = false;
            this.$emit("emitChangeSearchField", n);
          }
        }, 500);
      } else if (n !== o) this.$emit("emitChangeSearchField", n);
    },
    pagination: function (n, o) {
      if (n == o || n < 0 || n > 20) return;
      this.per_page = n;
    },
    filterOn: function (n, o) {
      if (n == o) return;
      this.$emit("emitChangeFilterOn", n);
    },
    current_page() {
      this.emitActualItems();
    },
    per_page() {
      this.emitActualItems();
    },
    fields: {
      handler(newFields) {
        this.columns_selected = newFields;
      },
      deep: true,
    },
    items: {
      handler() {
        this.filtered_items = this.$props.items;
        this.emitActualItems();
      },
    },
    item_created_id() {
      this.slotSortChanged(this.$props);
      if (!this.item_created_id) return;
      if (this.table_items) {
        this.table_items.forEach((row, index) => {
          row["row_index"] = index;
        });
        const new_item = this.table_items.find(
          (x) => x.id == this.item_created_id
        );
        if (new_item) {
          if (new_item.row_index <= this.per_page - 1) {
            clearTimeout(this.timeoutId);
            this.timeoutId = setTimeout(() => {
              const element = document.getElementById(
                `generic-table__row_${this.item_created_id}`
              );
              if (element) {
                element.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "nearest",
                });
              }
            }, 500);
          } else {
            const max_pages = Math.ceil(
              this.table_items.length / this.per_page
            );
            if (new_item.row_index % this.per_page == 0) {
              this.current_page += 1;
              if (this.current_page >= this.max_pages)
                this.current_page = max_pages + 1;
            } else {
              this.current_page = Math.ceil(new_item.row_index / this.per_page);
              if (this.current_page >= this.max_pages)
                this.current_page = max_pages;
            }
            clearTimeout(this.timeoutId);
            this.timeoutId = setTimeout(() => {
              const element = document.getElementById(
                `generic-table__row_${this.item_created_id}`
              );
              if (element) {
                element.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "nearest",
                });
              }
            }, 500);
          }
        }
      }
    },
  },
  created() {
    if (this.show_skeleton_efect) this.is_loading = true;
  },
  mounted() {
    this.total_rows = this.table_items.length;
    setTimeout(() => {
      this.slotSortChanged(this.$props);
    }, 1500);
  },
};
</script>

<style scoped>
.custom-span-pagination {
  min-width: 90px !important;
  color: var(--kl-text-muted);
  font-size: var(--kl-fs-small);
  font-weight: var(--kl-fw-semibold);
  white-space: nowrap;
}
/* Input "Por página" según el estándar (--kl-input-*) */
.custom-input-pagination {
  margin: 0px !important;
  width: 64px;
  height: 32px;
  text-align: center;
  font-size: var(--kl-fs-small);
  color: var(--kl-text-body);
  border: 1px solid var(--kl-input-border);
  border-radius: var(--kl-input-radius) !important;
}
.custom-input-pagination:focus {
  border-color: var(--kl-input-border-focus);
  box-shadow: var(--kl-shadow-focus);
}
/* ----- Barra de paginación según el estándar (styles_kl.css) ----- */
.pagination-bar {
  align-items: center;
  gap: 8px;
}
.pagination-bar >>> .pagination {
  margin-bottom: 0;
}
.pagination-bar >>> .page-item {
  margin-left: 4px;
}
/* Indicadores de página tipo píldora */
.pagination-bar >>> .page-link {
  min-width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  border: 1px solid var(--kl-border-soft);
  border-radius: var(--kl-radius-md) !important;
  background: var(--kl-surface);
  color: var(--kl-text-body);
  font-size: var(--kl-fs-small);
  font-weight: var(--kl-fw-semibold);
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}
.pagination-bar >>> .page-link:hover {
  background: var(--kl-surface-hover);
  color: var(--kl-color-primary);
  border-color: var(--kl-color-accent-border);
}
.pagination-bar >>> .page-link:focus {
  box-shadow: var(--kl-shadow-focus);
}
.pagination-bar >>> .page-item.active .page-link {
  background: var(--kl-color-primary);
  border-color: var(--kl-color-primary);
  color: var(--kl-text-on-primary);
}
.pagination-bar >>> .page-item.disabled .page-link {
  background: var(--kl-surface-muted);
  color: var(--kl-text-muted);
  border-color: var(--kl-border-soft);
}
/* Buscador y botones de columnas siempre en la misma fila (en pantallas
   pequeñas el input se encoge en vez de empujar la tuerca a otra fila). */
.flex-container {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 1.5em;
}
.search {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
}
#search-form {
  height: var(--kl-input-height) !important;
}
/* ----- Input de búsqueda según el estándar (--kl-input-*) ----- */
.search >>> .input-group-text {
  background: var(--kl-surface);
  border: 1px solid var(--kl-input-border);
  border-right: none;
  border-radius: var(--kl-input-radius) 0 0 var(--kl-input-radius);
  color: var(--kl-text-muted);
}
.search >>> #search-form {
  border: 1px solid var(--kl-input-border);
  border-left: none;
  /* El botón Limpiar va separado (margen), así que el input cierra redondeado
     a la derecha (Bootstrap lo cuadra por defecto al haber un append). */
  border-radius: 0 var(--kl-input-radius) var(--kl-input-radius) 0 !important;
  font-size: var(--kl-input-fs);
  color: var(--kl-text-body);
}
.search >>> #search-form:focus {
  border-color: var(--kl-input-border-focus);
  box-shadow: var(--kl-shadow-focus);
}
/* ----- Botón Limpiar según el estándar (--kl-btn-*) ----- */
.btn-clear {
  background: var(--kl-surface) !important;
  color: var(--kl-text-body) !important;
  border: 1px solid var(--kl-border) !important;
  border-radius: var(--kl-btn-radius) !important;
  font-size: var(--kl-btn-fs);
  font-weight: var(--kl-btn-fw);
  margin-left: 8px;
  transition: background 0.2s ease;
}
.btn-clear:hover:not(:disabled) {
  background: var(--kl-surface-hover) !important;
}
.col-display-1,
.col-display-2 {
  margin-left: 0.3em;
  color: var(--kl-text-on-primary);
  border-radius: var(--kl-btn-radius) !important;
  font-size: var(--kl-btn-fs);
  font-weight: var(--kl-btn-fw);
  border: none;
  /* Misma altura que la tuerca (VisibleColumns) y el input de búsqueda */
  height: var(--kl-input-height);
}
.col-display-1:hover,
.col-display-2:hover {
  transition: all 0.3s;
}
.col-popover-1 {
  z-index: 1010 !important;
}
.column-selector {
  width: auto;
  margin-left: 0em;
}
.column-check {
  text-align: left;
}
.filter-by-column {
  width: 100%;
}
.filter-on-check {
  width: 300px;
}
.filteron-popover {
  width: 170px;
}
.custom-control-inline {
  margin-right: 0;
}
.custom-th {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.custom-row {
  margin-bottom: 1rem;
}
.b-table-container {
  margin: 1rem 1rem 0rem 1rem;
}
/* Encabezado de tablas: celeste claro con texto azul (estilo dashboard) */
.b-table-container >>> .b-card-style th {
  background: var(--kl-table-header-bg) !important;
  color: var(--kl-table-header-text) !important;
  font-weight: var(--kl-fw-bold);
  font-size: var(--kl-table-header-fs);
  text-transform: uppercase;
  letter-spacing: var(--kl-ls-wide);
  padding: 11px 12px !important;
  border: none !important;
  vertical-align: middle;
  white-space: normal;
}
.form-group {
  margin-bottom: 0rem;
}
.per-page-container {
  display: flex;
}
.per-page-col {
  margin-top: 0.4rem;
  max-width: 320px;
}
.per-page-input-append {
  margin-top: 8%;
  max-width: 300px;
  font-size: 11pt;
}
.footer-caption {
  color: var(--kl-text-muted);
  font-size: var(--kl-fs-small);
  padding-top: 0;
  float: left;
  transform: translateX(10%);
  margin-right: -200px;
}
.b-table-container >>> .custom-footer {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  width: 100% !important;
}
.columns-btn {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-left: auto;
  flex-shrink: 0;
}
.popover {
  z-index: 10 !important;
}
.sort-arrow {
  width: 0.5rem;
  height: 0.9rem;
  margin-left: 4px;
  transform: none;
}
.no-header >>> .table.b-table > thead {
  display: none;
}
/* ----- Estilo visual unificado (igual a las tablas del dashboard) ----- */
/* Contenedor con esquinas redondeadas y borde suave */
.b-table-container >>> .table-responsive {
  border-radius: var(--kl-table-radius);
  border: 1px solid var(--kl-table-border);
}
.b-table-container >>> .generic-table {
  margin-bottom: 0;
}
/* Celdas del cuerpo */
.b-table-container >>> .generic-table tbody td {
  color: var(--kl-table-text);
  font-size: var(--kl-table-fs);
  padding: 11px 12px !important;
  border: none !important;
  border-bottom: 1px solid var(--kl-border-soft) !important;
  vertical-align: middle;
}
/* Filas: blancas por defecto, alternadas en celeste muy claro + hover.
El td pinta por encima del striped de Bootstrap, así que controla el color. */
.b-table-container >>> .generic-table tbody tr > td {
  background-color: var(--kl-table-row-bg);
}
.b-table-container >>> .generic-table tbody tr:nth-child(even) > td {
  background-color: var(--kl-table-row-alt-bg);
}
.b-table-container >>> .generic-table tbody tr:hover > td {
  background-color: var(--kl-table-row-hover-bg);
}
/* Conserva el resaltado de fila seleccionada (modo selección) */
.b-table-container >>> .generic-table tbody tr.b-table-row-selected > td {
  background-color: var(--kl-table-row-selected-bg) !important;
}
@media (max-width: 991px) {
  /* Se mantiene todo en una fila: el input se encoge y los botones de
     columnas se compactan en vez de bajar a una segunda fila. */
  .column-selector {
    margin-left: 0;
    width: auto;
  }
  .col-display-1,
  .col-display-2 {
    min-width: 0;
    margin: 0;
    width: auto;
    white-space: nowrap;
  }
  .filteron-popover {
    width: 180px !important;
    margin: 0;
  }
  .filter-by-column {
    width: auto !important;
  }
  i {
    margin-right: auto;
  }
}
/* Css para ocultar imagen de sorting por defecto en b-table */
.b-table-container >>> .table.b-table > thead > tr > [aria-sort="none"],
.b-table-container >>> .table.b-table > thead > tr > [aria-sort="ascending"],
.b-table-container >>> .table.b-table > thead > tr > [aria-sort="descending"] {
  background-image: none !important;
}
/* Css para íconos de bootstrap */
/*
.sort-arrows {
  display: flex;
  flex-direction: column;
}
.arrow-down {
  transform: rotate(180deg) translateY(40%);
} */
@media print {
  .generic-table {
    overflow: hidden !important;
  }
}
</style>